(function() {

	angular
		.module('ngmvac')
		.directive('datePick', DatePickerDirective);

	function DatePickerDirective() {
		return {
			restrict: 'A',
			scope: {
				date: '=',
				onChange: '&'
			},
			template: '<input type="text" class="form-control" />',
			link: function(scope, element, attrs) {
				

				scope.change = function(date) {
					 
					var ant; 
					if( attrs.pickerId == 'checkIn' ) {
						scope.$apply(function() {
							scope.$parent.cotizador.initialStay.checkIn = date;
						});	

						ant = scope.$parent.cotizador.initialStay.checkOut;
						if( date.isSameOrAfter(ant) ) {
							var aux = date.clone();
							ant = aux.add(3, 'days');
							console.log('Error en el checkin');
							console.log(ant);
						}
					} 

					if( attrs.pickerId == 'checkOut' ) {
						scope.$apply(function() {
							scope.$parent.cotizador.initialStay.checkOut = date;
						});

						ant = scope.$parent.cotizador.initialStay.checkIn;
						if( date.isSameOrBefore(ant) ) {
							console.log('Error en checkOut');
						}
					}

					console.log(ant);
					console.log(date);
				}

				scope.dateBlock = function(day) {

					if( attrs.pickerId == 'checkOut' )
						return day.isSameOrBefore(scope.$parent.cotizador.initialStay.checkIn);

					return false;
				}

				scope.$watch(scope.date, function() {
					ReactDOM.render(
						React.createElement(DatePicker.default, {
							idPicker: attrs.pickerId,
							initDate: scope.date.format('MM/DD/YYYY'),
							changeDate: scope.change,
							isDateBlocked: scope.dateBlock

						}),
						element[0]
					);
					console.log('Actualizacion');
				});

			}
		}
	}

})();